import React, { useState } from 'react'
import DrawerCompanyMenu from '../mobile/DrawerCompanyMenu'
import { Button } from '@material-tailwind/react';
import DrawerViewBalancesByContract from '../../pages/contract/viewBalances/DrawerViewBalancesByContract';
import { RolesType } from '../../utils/roles';

const HeaderContractMobile = ({ data, roles }: {
    data: any
    roles: RolesType | undefined
}) => {

    const [isOpenCard, setIsOpenCard] = useState<boolean>(false);

    const closeDrawer = () => {
        setIsOpenCard(false)
    }
    const openDrawer = () => {
        setIsOpenCard(true)
    }

    const [isOpenBalancesDrawer, setIsOpenBalancesDrawer] = useState(false);
    const [balanceKey, setBalanceKey] = useState<number>(1);

    const handleOpenBalances = (key: string) => {
        closeDrawer()
        setIsOpenBalancesDrawer(true)
        setBalanceKey(Number((key.replace('balance_', ''))))
    }

    const handleCloseBalances = () => {
        setIsOpenBalancesDrawer(false)
        setBalanceKey(0)
    }

    return (
        data ?
            <div className='lap:hidden'>
                <DrawerViewBalancesByContract
                    open={isOpenBalancesDrawer}
                    handleClose={handleCloseBalances}
                    balanceKey={balanceKey}
                />
                <Button size='sm' color='white' className='bg-gray-100 border-0 w-[32px] h-[32px] !p-[8px] flex flex-col justify-center gap-[3px]' onClick={openDrawer}>
                    <span className="block w-full h-[2px] bg-gray-800 rounded"></span>
                    <span className="block w-full h-[2px] bg-gray-800 rounded"></span>
                    <span className="block w-full h-[2px] bg-gray-800 rounded"></span>
                </Button>
                <DrawerCompanyMenu
                    roles={roles}
                    isShowMainButtons
                    isOpen={isOpenCard}
                    closeDrawer={closeDrawer}
                    modalValue={data}
                    handleOpenBalances={handleOpenBalances}
                />
            </div>
            :
            <></>
    )
}

export default HeaderContractMobile